let Alert = require('../components/alert');

let modals = {};

modals.init = function () {
	modals.modal();
	let alertType = modals.URL('alert')

	if (alertType != undefined) {
		Alert.show(alertType, 'title here', 'message here');
	}
}

modals.modal = function () {
		$('.modal').on('shown.bs.modal', function () {
			window.disableBodyScroll(true, '#'+ $(this).attr('id'));
		});
	
		$('.modal').on('hidden.bs.modal', function () {
			window.disableBodyScroll(false, '#'+ $(this).attr('id'));
		});

		$('#js-newsletter-modal').on('shown.bs.modal', function () {
			document.documentElement.classList.add('no-scroll');
		});
	
		$('#js-newsletter-modal').on('hidden.bs.modal', function () {
			document.documentElement.classList.remove('no-scroll');
		})
};


modals.URL = function(name) {
	/* eslint-disable no-useless-escape */
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	let results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

modals.init();


// WEBPACK FOOTER //
// ./scripts/components/modal.js